import { useTranslation } from 'react-i18next'
import styles from './index.module.less'
import type { IResAgsPledgeListItem } from '@/api/account/interface.ts'
import { getFormatTimeZone } from '@/utils'
import { ugagToGag, ugeaToGea2 } from '@/utils/number'
import classNames from 'classnames'

const AgsCard = (props: IResAgsPledgeListItem) => {
  const { t } = useTranslation()
  const startTime = getFormatTimeZone(props.startTime.replace(/-/g, '/').replace(' UTC', ''))
  const endTime = getFormatTimeZone(props.endTime.replace(/-/g, '/').replace(' UTC', ''))
  const amount = ugeaToGea2(props.amount)
  const interestAmount = ugeaToGea2(props.interestAmount)
  const interestAmountGag = ugagToGag(props.interestAmount)
  return (
    <div>
      <div className={styles.wrap}>
        <div>
          {/* 质押时间 */}
          <div className={styles.title}>{t('explorer_203')}</div>
          <div className={styles.textStyleFive}>
            <div>
              {startTime.timeUtc0 || '-'}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                （UTC+0）
              </span>
            </div>
            <div>
              {startTime.currentTime || '-'}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                （{t('explorer_95')}）
              </span>
            </div>
          </div>
        </div>
        <div>
          {/* 数量 */}
          <div className={styles.title}>{t('explorer_105')}</div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
            })}
          >
            <span>{amount.value}</span>{' '}
            <span className={styles.textStyleThree}>{amount.sigin}</span>
          </div>
        </div>
        <div>
          <div className={styles.title}>{t('explorer_204')}</div>
          <div className={styles.textStyleFive}>
            <div>
              <span>{interestAmount.value}</span>{' '}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                {interestAmount.sigin}
              </span>
            </div>
            <div>
              <span>{interestAmountGag.value}</span>{' '}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                {interestAmountGag.sigin}
              </span>
            </div>
          </div>
        </div>
        <div>
          {/* 到期时间 */}
          <div className={styles.title}>{t('explorer_205')}</div>
          <div className={styles.textStyleFive}>
            <div>
              {endTime.timeUtc0 || '-'}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                （UTC+0）
              </span>
            </div>
            <div>
              {endTime.currentTime || '-'}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                （{t('explorer_95')}）
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.mobileWrap}>
        <div className="area_a">
          {/* 数量 */}
          <div className={styles.title}>{t('explorer_105')}</div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
            })}
          >
            <span>{amount.value} </span>{' '}
            <span
              className={classNames({
                [styles.textStyleThree]: true,
                font_14: true,
              })}
            >
              {amount.sigin}
            </span>
          </div>
        </div>
        <div className="area_b">
          {/* 预计到期奖励 */}
          <div className={styles.title}>{t('explorer_204')}</div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
              [styles.flex_wrap]: true,
              [styles.flex_end]: true,
            })}
          >
            <div>
              <span>{interestAmount.value}</span>{' '}
              <span
                className={classNames({
                  [styles.textStyleThree]: true,
                  font_14: true,
                })}
              >
                {interestAmount.sigin}
              </span>
            </div>
            <div>
              <span>{interestAmountGag.value}</span>{' '}
              <span
                className={classNames({
                  [styles.textStyleThree]: true,
                  font_14: true,
                })}
              >
                {interestAmountGag.sigin}
              </span>
            </div>
          </div>
        </div>
        <div className="area_c">
          {/* 质押时间 */}
          <div className={styles.title}>{t('explorer_203')}</div>
          <div
            className={classNames({
              [styles.textStyleFive]: true,
              font_14: true,
            })}
          >
            <div>
              <span>{startTime.timeUtc0 || '-'}</span>{' '}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                (UTC+0)
              </span>
            </div>
            <div>
              <span>{startTime.currentTime || '-'}</span>
              {/* （当前时区） */}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                ({t('explorer_95')})
              </span>
            </div>
          </div>
        </div>
        <div className="area_d">
          {/* 到期时间 */}
          <div className={styles.title}>{t('explorer_205')}</div>
          <div
            className={classNames({
              [styles.textStyleFive]: true,
              font_14: true,
            })}
          >
            <div>
              <span>{endTime.timeUtc0 || '-'}</span>{' '}
              <span className={classNames(styles.textStyleFour, 'font_14')}>(UTC+0)</span>
            </div>
            <div>
              <span>{endTime.currentTime || '-'}</span>{' '}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                ({t('explorer_95')})
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgsCard
